module.exports = {
    TILE: 'tile',
    TEXT: 'text'
}